import { useQuery } from '@apollo/client';
import { GET_PEAK_LIST_ITEMS, SuccessResponse } from './query';

export const usePeakListItems = (peakListId: string) => useQuery<SuccessResponse, {id: string}>(
  GET_PEAK_LIST_ITEMS, {
    variables: { id: peakListId },
  });
